import { fetcher, SHOW_ERROR_PAGE_ON_FETCH_FAIL } from '@features/common';

const endpoint = '/api/v1/hr/payroll/requests';

// Used by dashboard widgets too: a failure must surface in the caller's own
// failed state, not replace the whole page with the global error screen.
// Query params are not snake-cased by the fetcher, so they are passed as the
// backend names them (page, limit, status, employee_id).
export function fetchPayrollRequests(params) {
  return fetcher.get(endpoint, {
    params,
    meta: { [SHOW_ERROR_PAGE_ON_FETCH_FAIL]: false },
  });
}

/** @param {{ month: number, year: number, reason: string, notes?: string }} data */
export function createPayrollRequest(data) {
  return fetcher.post(endpoint, data);
}

/**
 * @param {{ id: number, status: 'approved' | 'rejected', rejectionReason?: string, notes?: string }} decision
 */
export function decidePayrollRequest({ id, ...decision }) {
  return fetcher.patch(`${endpoint}/${id}/decision`, decision);
}
